import config from '../../constants/config.js';
import LocalizedStrings from 'react-localization';

import EN from './en';
import ES from './es';
import DA from './da';
import DE from './de';
import FI from './fi';
import SV from './sv';
import FR from './fr';
import HU from './hu';
import { customEn, customEs, customDa, customDe, customFi, customSv, customFr, customHu } from '../../constants/custom.localization';

let strings = new LocalizedStrings({
  en: {...EN, ...customEn},
  es: {...EN, ...ES, ...customEs},
  da: {...EN, ...DA, ...customDa},
  de: {...EN, ...DE, ...customDe},
  fi: {...EN, ...FI, ...customFi},
  sv: {...EN, ...SV, ...customSv},
  fr: {...EN, ...FR, ...customFr},
  hu: {...EN, ...HU, ...customHu}
});

let userLang = navigator.language || navigator.userLanguage || '';
const browserCode = userLang.split('-', 2)[0];

if (config.SUPPORTED_LANGUAGES.includes(browserCode)) {
  strings.setLanguage(browserCode);
} else {
  strings.setLanguage(config.LANGUAGE);
}

export default strings;
